module.exports = __webpack_public_path__ + "static/media/girl2.8c5d51c7.jpeg";